__turbopack_context__.v({
  "audurNavigationDropdown": "Topnavigation-module-scss-module__A1NcNW__audurNavigationDropdown",
  "darkFill": "Topnavigation-module-scss-module__A1NcNW__darkFill",
  "link-children": "Topnavigation-module-scss-module__A1NcNW__link-children",
  "loginButtons": "Topnavigation-module-scss-module__A1NcNW__loginButtons",
  "logo": "Topnavigation-module-scss-module__A1NcNW__logo",
  "logoContainer": "Topnavigation-module-scss-module__A1NcNW__logoContainer",
  "mobileAddAccountButton": "Topnavigation-module-scss-module__A1NcNW__mobileAddAccountButton",
  "mobileHamburgerButton": "Topnavigation-module-scss-module__A1NcNW__mobileHamburgerButton",
  "mobileLoginButton": "Topnavigation-module-scss-module__A1NcNW__mobileLoginButton",
  "navigationButtonContent": "Topnavigation-module-scss-module__A1NcNW__navigationButtonContent",
  "navigationContainer": "Topnavigation-module-scss-module__A1NcNW__navigationContainer",
  "navigationDropdownButton": "Topnavigation-module-scss-module__A1NcNW__navigationDropdownButton",
  "navigationDropdownButtonMobile": "Topnavigation-module-scss-module__A1NcNW__navigationDropdownButtonMobile",
  "outerContainer": "Topnavigation-module-scss-module__A1NcNW__outerContainer",
  "whiteFill": "Topnavigation-module-scss-module__A1NcNW__whiteFill",
});
